var __rspack_ns_object = JSON.parse('{"holiday-type":"Holiday type"}')